import { render, staticRenderFns } from "./O365LoginSucceeded.vue?vue&type=template&id=79e8839c"
import script from "./O365LoginSucceeded.vue?vue&type=script&lang=ts"
export * from "./O365LoginSucceeded.vue?vue&type=script&lang=ts"
import style0 from "./O365LoginSucceeded.vue?vue&type=style&index=0&id=79e8839c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports